import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import Header from '../Header/Header';
import ExpertiseCard, { expertiseData } from './ExpertiseCard';
import IndustryCard, { industriesData } from './IndustryCard';

export default function Main() {
  const navigate = useNavigate();
  const techImages = [
    'node.png','rails.png','snowflake.png','swift-removebg-preview.png','react.svg','angular.png','python.png',
    'aws-removebg-preview.png','azure-removebg-preview.png','gcp-removebg-preview.png','langchain-removebg-preview.png','langgraph-removebg-preview.png',
    'databricks-removebg-preview.png','palantir-removebg-preview.png','shopify-removebg-preview.png','devops.png'];

  return (
  <>
    <Header isActive={"Home"}/>
    <div id="content" className="site-content">
    <section className="banner big-padding-top bg-banner-gradient particles-js" data-color="#ffffff, #00c3ff, #fe4c1c" data-id="i1">
      <div className="bg-overlay-1"></div>
      <div className="shape shape-bottom" data-negative="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none">
          <path className="shape-fill" d="M500,97C126.7,96.3,0.8,19.8,0,0v100l1000,0V1C1000,19.4,873.3,97.8,500,97z"></path>
        </svg>
      </div>
      <div className="banner-wrap">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="banner-stitle m-b55 xs-m-b40">Hire On Demand Developers<br></br><span className="text-second">Whatever your requirements we’ll connect you with the perfect candidates to drive your business forward.</span></h2>
              <div className="wpcf7 lead">
                <div className="screen-reader-response"></div>
                <form action="resources/functions/lead-form-process.php" method="POST" className="lead-form wpcf7-form">
                  <div className="one-line-form">
                    <span>
                      <input type="text" className="lead-text form-control" name="name" id="name" placeholder="Enter your name" required />
                    </span>
                    <span className="your-mobile">
                      <input type="number" className="lead-text form-control" name="mobile" id="mobile" placeholder="Enter your mobile number" maxLength="10" required />
                    </span>
                    <input type="hidden" name="recaptcha_response" id="recaptchaResponse" />
                    <button type="button" onClick={() => navigate('/contact')} className="octf-btn octf-btn-icon octf-btn-primary">Start Now<i className="flaticon-right-arrow-1"></i></button>
                  </div>
                  <div className="form-group">
                    <div className="form-loading">Loading</div>
                    <div className="form-error-message"></div>
                    <div className="form-sent-message">Thank you for contacting us!</div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
{/* 
    <section className="about-home bg-light">
      <div className="container">
        <div className="about-home-img text-center">
          <img src={`${process.env.PUBLIC_URL}/resources/images/topimg-home1.png`} alt="ProSkillHub" />
        </div>
      </div>
    </section> */}

    <section className="seo-about p-b30">
      <div className="shape shape-bottom" data-negative="false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none">
          <path className="shape-fill" d="M1000,4.3V0H0v4.3C0.9,23.1,126.7,99.2,500,100S1000,22.7,1000,4.3z"></path>
        </svg>
      </div>
      <div className="container">
        <div className="row">
          <div className="top-up">
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
              <Link to="/IT-consulting" className="icon-box s3 box-hover-gradient text-center" style={{ display: 'block' }}>
                <div className="bg-s3"></div>
                <div className="bg-before" style={{ background: `url(${process.env.PUBLIC_URL}/resources/images/bg1-box.png) top left no-repeat #fff` }}></div>
                <div className="bg-after" style={{ background: `url(${process.env.PUBLIC_URL}/resources/images/bg2-box.png) bottom right no-repeat #fff` }}></div>
                <div className="icon-main"> <span className="flaticon-startup"></span> </div>
                <div className="content-box">
                  <h5>IT Consulting</h5>
                  <p>Humanix Technologies streamline complexity to deliver digital success, helping you achieve cost savings of 70-75%.</p>
                </div>
              </Link>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 m-t50">
              <Link to="/Permanent-staffing" className="icon-box s3 box-hover-gradient text-center" style={{ display: 'block' }}>
                <div className="bg-s3"></div>
                <div className="bg-before" style={{ background: `url(${process.env.PUBLIC_URL}/resources/images/bg1-box2.png) top left no-repeat #fff` }}></div>
                <div className="bg-after" style={{ background: `url(${process.env.PUBLIC_URL}/resources/images/bg2-box2.png) bottom right no-repeat #fff` }}></div>
                <div className="icon-main"> <span className="flaticon-system"></span> </div>
                <div className="content-box">
                  <h5>Permanent Staffing</h5>
                  <p>With a talent pool of over 2,000 top-tier professionals and expertise across diverse technologies, we ensure recruitment in a short timeframe.</p>
                </div>
              </Link>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 xs-m-t50">
              <Link to="/Temporary-staffing" className="icon-box s3 box-hover-gradient text-center" style={{ display: 'block' }}>
                <div className="bg-s3"></div>
                <div className="bg-before" style={{ background: `url(${process.env.PUBLIC_URL}/resources/images/bg1-box3.png) top right no-repeat #fff` }}></div>
                <div className="bg-after" style={{ background: `url(${process.env.PUBLIC_URL}/resources/images/bg2-box3.png) bottom left no-repeat #fff` }}></div>
                <div className="icon-main"> <span className="flaticon-internet"></span> </div>
                <div className="content-box">
                  <h5>Temporary Staffing</h5>
                  <p>
                  Over 1,000+ skilled professionals, swift short-term placements, 100% data security, and immediate processing.</p>
                </div>
              </Link>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 m-t50">
              <Link to="/Staff-augmentation" className="icon-box s3 box-hover-gradient text-center" style={{ display: 'block' }}>
                <div className="bg-s3"></div>
                <div className="bg-before" style={{ background: `url(${process.env.PUBLIC_URL}/resources/images/bg1-box2.png) top left no-repeat #fff` }}></div>
                <div className="bg-after"></div>
                <div className="icon-main"> <span className="flaticon-report"></span> </div>
                <div className="content-box">
                  <h5>Software Development</h5>
                  <p>Fast and efficient, 100% personalized, and completely adaptable.</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
{/*     
    <section className="container">
        <div className="row p-b40">
          <div className="col-sm-8 xs-m-b40">
            <div className="ot-heading">
              <h2 className="main-heading">Meet Our Selected Candidates</h2>
            </div>
            <p className="m-b0">ProskillHub transforms you into a highly skilled Software Professional</p>
          </div>
          <div className="col-sm-4">
            <div className="ot-button text-right xs-text-left m-t15">
              <a href="candidates.html" className="octf-btn octf-btn-primary octf-btn-icon">
                <span>All Candidates <i className="flaticon-right-arrow-1"></i></span>
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 p-b75">
            <div className="team-slider">
              {[
                { name: 'Yogendra Mohan', role: 'Backend Developer', img: 'condidate-1.jpg', github: 'https://github.com/SuryaPratapSing', linkedin: 'https://www.linkedin.com/in/iamsinghsurya/' },
                { name: 'Gourav Sengar', role: 'RoR Developer', img: 'condidate-10.jpg', github: '#', linkedin: '#' },
                { name: 'Ankit Pandey', role: 'Backend Developer', img: 'condidate-3.jpg', github: '#', linkedin: '#' },
                { name: 'Sanjana Patel', role: 'Backend Developer', img: 'condidate-4.jpg', github: '#', linkedin: '#' },
                { name: 'Shankarshan Mishra', role: 'Backend Developer', img: 'condidate-5.jpg', github: '#', linkedin: '#' },
                { name: 'Krishna Mishra', role: 'Byju\'s', img: 'condidate-6.jpg', github: '#', linkedin: '#' },
                { name: 'Prabal Pathak', role: 'RoR Developer', img: 'condidate-7.jpg', github: '#', linkedin: '#' },
                { name: 'Laxmi Mishra', role: 'RoR Developer', img: 'condidate-8.jpg', github: '#', linkedin: '#' },
                { name: 'Prabhat Mishra', role: 'React Developer', img: 'condidate-9.jpg', github: '#', linkedin: '#' },
                { name: 'Abhinav Kushwaha', role: 'RoR Developer', img: 'condidate-11.jpg', github: '#', linkedin: '#' },
                { name: 'Rohit Mishra', role: 'Physicswallah', img: 'condidate-2.jpg', github: '#', linkedin: '#' }
              ].map((candidate, index) => (
                <div className="team-wrap" key={index}>
                  <div className="team-thumb">
                    <img src={`resources/images/students/${candidate.img}`} alt={candidate.name} />
                  </div>
                  <div className="team-info">
                    <h4>{candidate.name}</h4>
                    <span>{candidate.role}</span>
                    <div className="team-social">
                      <a className="github" target="_blank" href={candidate.github}>
                        <i className="fa-brands fa-github"></i>
                      </a>
                      <a className="linkedin" target="_blank" href={candidate.linkedin}>
                        <i className="fa-brands fa-linkedin-in"></i>
                      </a>
                      <span className="flaticon-add-1"></span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section> */}
      
      <section className="p-t35 p-b90 xs-p-t60 xs-p-b60 bg-about">
        <div className="container">
          <div className="ot-heading">
            <h6><span>About Us</span></h6>
            <h2 className="main-heading">About Humanix Technologies</h2>
          </div>

          <div className="row flex-row">
            <div className="col-lg-6 col-md-12 col-xs-12 xs-p-b50 text-center">
              <div className="about-image-frame">
                <img src="resources/images/about.jpg" alt="Humanix Technologies team" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-xs-12 p-l95 xs-p-l15 p-r0 xs-p-r15 align-self-center">
              <div className="ot-heading left-align">
                <h2 className="main-heading m-b20">Grow with Humanix</h2>
              </div>
              <p className="m-b0 p-b45 about-mobile">
              With exceptional analytical, strategic, and technical expertise, Humanix technologies offers talented on-demand developers who bring your ideas to life. Our developers and HR professionals quickly grasp your unique requirements and collaborate closely with your in-house team to ensure excellence at every stage. Having worked with a diverse portfolio, Humanix Technologies allows you the freedom to choose the best-fit resources by evaluating their skills and expertise to meet your specific needs.
              </p>
              <p className="font22 text-dark">We focus on strong partnerships built with Trust, Honesty, Collaboration and Transparency.</p>
              <p className="m-b0 p-b45 about-mobile">
              Humanix Technologies prioritizes client needs, consistently aiming to not only meet but exceed expectations. We continuously assess our current initiatives to inform future strategies, proactively anticipating and addressing client requirements before they emerge.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="p-t80 p-b80 xs-p-t60 xs-p-b60 timezone-section">
        <div className="container">
          <div className="row flex-row align-items-center">
            <div className="col-lg-6 col-md-12 col-xs-12 xs-m-b30">
              <div className="ot-heading left-align">
                <h6><span>Time Zone Alignment</span></h6>
                <h2 className="main-heading m-b0">Work With Our Team in Your Time Zone</h2>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-xs-12 align-self-center">
              <p className="m-b0">Stay connected with a team that works around your business hours, making communication, collaboration and day-to-day project work easier.</p>
            </div>
          </div>
          <div className="timezone-card">
            <div className="timezone-card-info">
              <h5>Working Hours That Fit Your Schedule</h5>
              <span>Mon &ndash; Fri &middot; 9am &ndash; 6pm (local time)</span>
            </div>
            <div className="timezone-card-grid">
              {[
                { country: 'United States', zone: 'EST', flag: 'us icon.png' },
                { country: 'United Kingdom', zone: 'GMT', flag: 'uk.png' },
                { country: 'Germany', zone: 'CET', flag: 'germany.png' },
                { country: 'Dubai', zone: 'GST', flag: 'dubai.png' },
                { country: 'Canada', zone: 'EST', flag: 'canda.png' },
              ].map((tz) => (
                <div className="timezone-item" key={tz.country}>
                  <img className="timezone-flag" src={`resources/images/flags/${tz.flag}`} alt={tz.country} />
                  <h6>{tz.country}</h6>
                  <span>{tz.zone}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container">
          <div className="row">
          <Swiper
        slidesPerView={2} // Number of slides visible at a time
        spaceBetween={10} // Space between slides
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        modules={[ Autoplay]} // Removed Navigation module
        breakpoints={{
          1024: { slidesPerView: 6 },
          768: { slidesPerView: 4 },
          640: { slidesPerView: 2 },
        }}
        className="partner-slider"
      >
            <div className="col-md-12">
              <div className="partners">
                <div className="owl-carousel home-client-carousel">
                  {[
                    'zoomcar-4.webp', 'zoomcar-10.webp', 'zoomcar-8.webp', 'zoomcar-6.webp', 'zoomcar-17.webp',
                    'cred.webp', 'delhiberry.webp', 'meeso.webp', 'paytm.webp', 'upgrad.webp', 'rakuten.png', 'delhiberry.webp'
                  ].map((logo, index) => (
                    <SwiperSlide key={index} className='mt-5'>
                    <div className="partners-slide" key={index}>
                      <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                          <img className="partners-slide-image" src={`resources/images/brands/${logo}`} alt="" />
                        </figure>
                      </a>
                    </div>
                    </SwiperSlide>
                  ))}
                </div>
              </div>
            </div>
            </Swiper >
          </div>
        </div>
      </section>
    
      <section className="p-b330">
    <div className="container">
        <div className="row">
        <Swiper
        slidesPerView={2} // Number of slides visible at a time
        spaceBetween={10} // Space between slides
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        modules={[ Autoplay]} // Removed Navigation module
        breakpoints={{
          1024: { slidesPerView: 6 },
          768: { slidesPerView: 4 },
          640: { slidesPerView: 2 },
        }}
        className="team-slider"
      >
            <div className="col-md-12">
                <div className="partners">
                    <div className="owl-carousel home-client-carousel">
                      {techImages.map((logo, index) =>  (
                        <SwiperSlide key={index} className='mt-5'>
                        <div className="partners-slide " key={index}>
                            <a href="#" className="client-logo">
                                <figure className="partners-slide-inner">
                                    <img className="partners-slide-image technology-img" src={`resources/images/brands/${logo}`} alt="" />
                                </figure>
                            </a>
                        </div>
                        </SwiperSlide>
                      ))}
                    </div>
                </div>
            </div>
            </Swiper >
        </div>
    </div>
</section>
<section className="expertise-section" aria-labelledby="expertise-title">
  <div className="container">
    <div className="expertise-heading">
      <h6><span>Our Expertise</span></h6>
      <h2 id="expertise-title" className="main-heading">Technology expertise that drives growth</h2>
      <p>End-to-end technology expertise to build, scale, optimize, and modernize your digital business.</p>
    </div>
    <div className="expertise-grid">
      {expertiseData.map((expertise) => (
        <ExpertiseCard key={expertise.title} expertise={expertise} />
      ))}
    </div>
    <div className="expertise-cta">
      <h3>Have a technology challenge?</h3>
      <p>Let's build the right solution together.</p>
      <a className="octf-btn octf-btn-primary octf-btn-icon" href="/contact">
        <span>Talk to Our Experts <i className="flaticon-right-arrow-1"></i></span>
      </a>
    </div>
  </div>
</section>
<section id="industries" className="industries-section" aria-labelledby="industries-title">
  <div className="container">
    <div className="industries-heading">
      <h6><span>Industries We Serve</span></h6>
      <h2 id="industries-title" className="main-heading">Innovative solutions across every industry</h2>
      <p>We combine deep industry knowledge with technology expertise to help organizations optimize, transform, and innovate.</p>
    </div>
    <div className="industries-grid">
      {industriesData.map((industry) => (
        <IndustryCard key={industry.title} industry={industry} />
      ))}
    </div>
  </div>
</section>

<section className="p-t35 p-b90 xs-p-t60 xs-p-b60">
  <div className="container">
    <div className="row flex-row">
      <div className="col-lg-6 col-md-12 col-xs-12 xs-p-b50 text-center">
        <div className="about-image-frame">
          <img src="resources/images/img.png" alt="Humanix Technologies case studies" />
        </div>
      </div>
      <div className="col-lg-6 col-md-12 col-xs-12 p-l95 xs-p-l15 p-r0 xs-p-r15 align-self-center">
        <div className="ot-heading left-align">
          <h6><span>Case Studies</span></h6>
          <h2 className="main-heading m-b20">See how we've helped teams ship real results</h2>
        </div>
        <p className="m-b0 p-b45 about-mobile">
          From AI chatbots to SRE observability platforms, explore how our on-demand teams have solved real engineering challenges across chatbots, data engineering, agentic AI, DevOps, MVPs, prototypes, and more.
        </p>
        <div className="ot-button">
          <a href="/case-studies" className="octf-btn octf-btn-secondary octf-btn-icon">
            <span>View Case Studies <i className="flaticon-right-arrow-1"></i></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-light">
    <div className="bg-overlay"></div>
    <div className="container">
        <div className="icon-box-grid text-center m-t--20">
            <div className="col-md-4 no-padding">
                <div className="icon-box text">
                    <div className="icon-main"> <span className="flaticon-coding"></span> </div>
                    <div className="content-box">
                        <h5>Frontend Developer</h5>
                        <div>
                            <span><i className="fa-solid fa-briefcase"></i> 90+ Developers </span>
                        </div>
                        <Link to="/contact" className="octf-btn octf-btn-icon octf-btn-primary">View Profiles <i className="flaticon-right-arrow-1"></i></Link>
                    </div>
                </div>
            </div>
            <div className="col-md-4 no-padding">
                <div className="icon-box">
                    <div className="icon-main"> <span className="flaticon-pie-chart-1"></span> </div>
                    <div className="content-box">
                        <h5>Backend Developer</h5>
                        <div>
                            <span><i className="fa-solid fa-briefcase"></i> 80+ Developers </span>
                        </div>
                        <Link to="/contact" className="octf-btn octf-btn-icon octf-btn-primary">View Profiles <i className="flaticon-right-arrow-1"></i></Link>
                    </div>
                </div>
            </div>
            <div className="col-md-4 no-padding">
                <div className="icon-box">
                    <div className="icon-main"> <span className="flaticon-document"></span> </div>
                    <div className="content-box">
                        <h5>Full stack Developer</h5>
                        <div>
                            <span><i className="fa-solid fa-briefcase"></i> 100+ Developers </span>
                        </div>
                        <Link to="/contact" className="octf-btn octf-btn-icon octf-btn-primary">View Profiles <i className="flaticon-right-arrow-1"></i></Link>
                    </div>
                </div>
            </div>
            <div className="col-md-4 no-padding">
                <div className="icon-box">
                    <div className="icon-main"> <span className="flaticon-search-1"></span> </div>
                    <div className="content-box">
                        <h5>Data Science</h5>
                        <div>
                            <span><i className="fa-solid fa-briefcase"></i> 75+ Developers </span>
                        </div>
                        <Link to="/contact" className="octf-btn octf-btn-icon octf-btn-primary">View Profiles <i className="flaticon-right-arrow-1"></i></Link>
                    </div>
                </div>
            </div>
            <div className="col-md-4 no-padding">
                <div className="icon-box">
                    <div className="icon-main"> <span className="flaticon-coding"></span> </div>
                    <div className="content-box">
                        <h5>Data Engineer</h5>
                        <div>
                            <span><i className="fa-solid fa-briefcase"></i> 65+ Developers </span>
                        </div>
                        <Link to="/contact" className="octf-btn octf-btn-icon octf-btn-primary">View Profiles <i className="flaticon-right-arrow-1"></i></Link>
                    </div>
                </div>
            </div>
            <div className="col-md-4 no-padding">
                <div className="icon-box">
                    <div className="icon-main"> <span className="flaticon-cloud-computing"></span> </div>
                    <div className="content-box">
                        <h5>DevOps</h5>
                        <div>
                            <span><i className="fa-solid fa-briefcase"></i> 70+ Developers </span>
                        </div>
                        <Link to="/contact" className="octf-btn octf-btn-icon octf-btn-primary">View Profiles <i className="flaticon-right-arrow-1"></i></Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
{/* <section className="p-b180 p-t120">
    <div className="container">
        <h2 className="main-heading">Our Selected Candidates</h2>
        <div className="row">
            <div className="col-md-12">
                <div className="partners">
                    <div className="owl-carousel home-client-carousel">
                        <div className="partners-slide">
                            <a href="#" className="client-logo">
                                <figure className="partners-slide-inner">
                                    <img className="partners-slide-image" src="resources/images/students/pic-1.png" alt="" />
                                </figure>
                            </a>
                            <p>React dev</p>
                        </div>
                        <div className="partners-slide">
                            <a href="#" className="client-logo">
                                <figure className="partners-slide-inner">
                                    <img className="partners-slide-image" src="resources/images/students/pic-2.png" alt="" />
                                </figure>
                            </a>
                            <p>RoR dev</p>
                        </div>
                        <div className="partners-slide">
                            <a href="#" className="client-logo">
                                <figure className="partners-slide-inner">
                                    <img className="partners-slide-image" src="resources/images/students/pic-3.png" alt="" />
                                </figure>
                            </a>
                            <p>Python dev</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> */}
{/* <section className="bg-dark text-light p-b130">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <div className="cta-btn text-center">
                    <h3>Are you ready to join our tech programs?</h3>
                    <a href="about-us.html" className="octf-btn octf-btn-icon octf-btn-primary">Join Now<i className="flaticon-right-arrow-1"></i></a>
                </div>
            </div>
        </div>
    </div>
</section> */}
<section className="p-t80 bg-testi">
    <div className="bg-overlay-testi"></div>
    <div className="container">
        <div className="row">
            <div className="col-md-4 col-xs-12 align-self-center">
                <div className="ot-heading heading-testimonials left-align">
                    <h6><span>Testimonials</span></h6>
                    <h2 className="main-heading">What They<br /> Say About Our<br />Company?</h2>
                </div>
            </div>
            <div className="col-md-8 col-xs-12">
                <Swiper
                    slidesPerView={1} // Only one slide visible at a time
                    spaceBetween={10} // Space between slides
                    loop={true}
                    autoplay={{
                        delay: 3000, // Delay between slide transitions
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay]} // Import Autoplay module
                    className="ot-testimonials-slider"
                >
                  {[
                    {
                      review: 'Humanix gave our product team the experienced engineers we needed to move from prototype to a reliable beta. Their developers understood our goals quickly and worked naturally with our in-house team.',
                      name: 'Oliver Bennett',
                      role: 'CTO, Northstar Labs, UK',
                    },
                    {
                      review: 'We brought Humanix in to rebuild the core of our customer platform. The developers were thoughtful, communicative, and consistently focused on shipping maintainable features rather than quick fixes.',
                      name: 'Maya Thompson',
                      role: 'CEO, Brightwell Systems, USA',
                    },
                    {
                      review: 'Our launch timeline was aggressive, but the Humanix team added the right product and engineering experience at exactly the right time. We reached production with a much stronger foundation than expected.',
                      name: 'Daniel Foster',
                      role: 'CTO, Calder Digital, UK',
                    },
                    {
                      review: 'Humanix supplied developers who could contribute from the first sprint. They asked sharp questions, adapted to our workflow, and helped us turn a complex roadmap into a sequence of practical releases.',
                      name: 'Avery Collins',
                      role: 'CEO, Harborline Health, USA',
                    },
                    {
                      review: 'The team helped us modernize a legacy application without disrupting our customers. Their engineers balanced delivery speed with careful testing, documentation, and a clear handover to our internal team.',
                      name: 'James Whitaker',
                      role: 'CTO, Wrenfield Group, UK',
                    },
                    {
                      review: 'We needed senior developers who could own difficult product decisions, not simply complete tickets. Humanix delivered a dependable team that improved both our delivery rhythm and the quality of the product.',
                      name: 'Lauren Brooks',
                      role: 'CEO, Meridian Commerce, USA',
                    },
                    {
                      review: 'Humanix helped us scale our engineering capacity during a critical customer rollout. The developers were collaborative, technically strong, and comfortable working across design, product, and infrastructure.',
                      name: 'Thomas Hughes',
                      role: 'CTO, Elm & Co., UK',
                    },
                    {
                      review: 'The engineers we received became productive members of our team very quickly. They brought useful product thinking to every discussion and helped us release a polished first version on schedule.',
                      name: 'Sofia Reynolds',
                      role: 'CEO, Atlas Grove, USA',
                    },
                    {
                      review: 'From architecture planning through post-launch improvements, Humanix provided steady support and practical advice. Their developers made a meaningful difference to our platform and our confidence in the roadmap.',
                      name: 'William Carter',
                      role: 'CTO, Redbrook Software, UK',
                    },
                    {
                      review: 'Humanix understood that we needed a product partner, not just extra hands. The developers brought clarity to a fast-moving project and helped us turn customer feedback into useful, well-built improvements.',
                      name: 'Grace Mitchell',
                      role: 'CEO, Pinecrest Ventures, USA',
                    },
                    {
                      review: 'The Humanix developers helped us turn a demanding technical brief into a stable, customer-ready product. Their ownership and attention to detail gave our leadership team real confidence throughout delivery.',
                      name: 'Ethan Wallace',
                      role: 'CTO, Larkspur Analytics, UK',
                    },
                    {
                      review: 'We needed an experienced team to accelerate our SaaS roadmap, and Humanix fit in exceptionally well. They delivered valuable features quickly while keeping the codebase clear and easy for us to extend.',
                      name: 'Chloe Morgan',
                      role: 'CEO, Westbridge Cloud, USA',
                    },
                    {
                      review: 'Our dedicated developers brought strong engineering judgement to a product with a lot of moving parts. Humanix helped us simplify the architecture and deliver a smoother experience for our customers.',
                      name: 'Arthur Davies',
                      role: 'CTO, Kestrel Works, UK',
                    },
                    {
                      review: 'Humanix gave our small team the capacity to build and launch a major product update without losing momentum. Their developers were proactive, dependable, and easy to work with across every stage.',
                      name: 'Natalie Parker',
                      role: 'CEO, Clearpath Retail, USA',
                    },
                    {
                      review: 'The developers quickly understood our domain and made a noticeable impact on both performance and delivery speed. Their documentation also made the transition to our internal team straightforward.',
                      name: 'George Harrison',
                      role: 'CTO, Oakmere Digital, UK',
                    },
                    {
                      review: 'We were impressed by how naturally the Humanix team worked with our product managers and designers. They helped us make better technical decisions and delivered a polished release our users appreciated.',
                      name: 'Rebecca Ellis',
                      role: 'CEO, Summit Ridge Tech, USA',
                    },
                    {
                      review: 'Humanix provided the senior development support we needed during a period of rapid growth. Their team improved our release process and helped us build a product that could scale with demand.',
                      name: 'Henry Lawson',
                      role: 'CTO, Fieldstone Apps, UK',
                    },
                    {
                      review: 'From the first planning session, the developers were focused on outcomes and customer value. They helped us move from an early concept to a dependable platform with a clear path for future improvements.',
                      name: 'Madison Reed',
                      role: 'CEO, Willow Peak, USA',
                    },
                    {
                      review: 'The Humanix team brought the right balance of technical depth and practical delivery. They strengthened our product, shared knowledge with our engineers, and helped us meet an important launch commitment.',
                      name: 'Edward Clarke',
                      role: 'CTO, Hartwell Systems, UK',
                    },
                  ].map(({ review, name, role }) => (
                    <SwiperSlide key={name}>
                      <div className="testimonial-inner">
                        <div className="ttext">{review}</div>
                        <div className="tinfo">
                          <h6>{name}</h6>
                          <span>{role}</span>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
            </div>
        </div>
    </div>
</section>


<section className="p-t330 p-b210 cta bg-cta particles-js" data-color="#fe4c1c,#00c3ff,#0160e7" data-id="i1-1">
    <div className="bg-overlay opacity-1"></div>
    <div className="shape shape-top" data-negative="false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none">
            <path className="shape-fill" d="M1000,4.3V0H0v4.3C0.9,23.1,126.7,99.2,500,100S1000,22.7,1000,4.3z"></path>
        </svg>
    </div>
    <div className="container">
        <div className="cta-content text-center">
            <h2 className="m-b20">Take Your Hiring to Next<br />Level Right Now!</h2>
            <p className="m-b35">Make the Right Choice for Your Future. Choose Humanix Technologies!</p>
            <div className="ot-button">
                <Link to="/contact" className="octf-btn octf-btn-primary octf-btn-icon"><span>Start Now<i className="flaticon-right-arrow-1"></i></span></Link>
            </div>

            <h4 className="developer-section-content">Hire 10+ Years Experienced Developer for your project.</h4>

            <div className="wpcf7 lead">
                <div className="screen-reader-response"></div>
                <form action="resources/functions/lead-form-process.php" method="POST" className="lead-form wpcf7-form">
                    <div className="one-line-form">
                        <span>
                            <input type="text" className="lead-text form-control" name="name" id="name" placeholder="Enter your name/mail" required />
                        </span>
                        <span className="your-mobile">
                            <input type="number" className="lead-text form-control" name="mobile" id="mobile" placeholder="Enter your mobile number"
                                onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }} 
                                maxLength="10" required />
                        </span>
                        <input type="hidden" name="recaptcha_response" id="recaptchaResponse" />
                        <button type="button" onClick={() => navigate('/contact')} className="octf-btn octf-btn-icon octf-btn-primary">Start Now<i className="flaticon-right-arrow-1"></i></button>
                    </div>
                    <div className="form-group">
                        <div className="form-loading">Loading</div>
                        <div className="form-error-message"></div>
                        <div className="form-sent-message">Thank you for contacting us!</div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>

    </div>
  </>
  )
}

